<div class="page-heading" id="subheading">
    <span class="page-heading-title">My Account</span>
</div>

<div id="innercontent" class="custom-scrollbar">
    <div class="container-fluid container-background">
        <div style="margin-left:25px">
            <br>
            <mat-tab-group style="margin-right:10%">
                <!-- User profile tab -->
                <mat-tab label="User Profile">
                    <div class="mt-4" *ngIf="selectedUser">
                        <app-edit-user-profile [selectedUser]="selectedUser" [isReadOnly]="true" />
                    </div>
                </mat-tab>
                <!-- Assignment tab -->
                <mat-tab label="Assignments">
                    <div class="flex flex-row">
                        <label style="align-content:center;font-size:18px;font-weight:bold">Assignments</label>
                        <mat-form-field class="filter-clients-and-accounts" id="filterClientsAndAccountsFormField"
                            floatLabel="never" appearance="fill">
                            <input matInput placeholder="Search" (keyup)="filterClientsAndAccountsByText()"
                                [(ngModel)]="filterText">
                            <mat-icon aria-hidden="false" aria-label="search icon" matSuffix>
                                search
                            </mat-icon>
                        </mat-form-field>
                    </div>
                    <mat-card
                        style="overflow-y:auto; max-height: 500px; width: 100%;border-radius:16px;box-shadow: none; margin-bottom:20px">
                        <mat-card-content>
                            <div class="flex flex-row assignments-header-table">
                                <button mat-icon-button class="btn btn-link btn-sm custom" (click)="toggleExpandAll()">
                                    <mat-icon>{{ expandAll ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                                </button>
                                <span class="access-header">Clients</span>
                            </div>
                            <div class="clients-accounts-data" *ngIf="selectedUser && hasClientAccounts">
                                <div *ngFor="let entry of clientAccountsDictionary | keyvalue">
                                    <app-edit-users-client-accounts [userId]="selectedUser.id"
                                        [userRoleId]="selectedUser.userRoleId" [loggedInUserAccounts]="entry.value"
                                        [editedUserClientAccounts]="filterClients(entry)"
                                        [expandClientAccounts]="expandAll" [isReadOnly]='true'
                                        (updateSaved)="reloadUpdatedUser($event)"
                                        (formSaveStateChanged)="onFormSaveStateChanged($event)" />
                                    <div class="line"></div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                <mat-tab label="User Activity">
                    <div *ngIf="selectedUser">
                        <app-user-activity [selectedUser]="selectedUser" ></app-user-activity>
                    </div>
                </mat-tab>

                <!-- Unavailable Schedule tab -->
                <mat-tab label="Availability" *ngIf="selectedUser && unavailabilityScheduleIsEnabled">
                    <app-unavailability-schedule [selectedUser]="selectedUser"></app-unavailability-schedule>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>